import Regulation from './regulation.js';
export default Regulation;
